import Vue from "vue";
import Router from "vue-router"

import LandingVideo from '@/components/pages/LandingVideo/LandingVideo';
import Home from '@/components/pages/Home/Home';


Vue.use(Router);

export default new Router({
    mode: 'history',
    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 }
        }
    },
    linkExactActiveClass: 'is-active',
    base: `2025-extension`,

    routes: [
        {
            path: "/:purl?",
            name: 'Home',
            component: Home
        },
        {
            path: "/:purl?/home",
            name: 'Home',
            component: Home
        },

    ]
});